import { deleteCookie, getCookie } from 'cookies-next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logoutUser } from '../redux/slices/authSlice';

export const fetchWithAuth = async (url: string, options: RequestInit = {}) => {
  // const dispatch = useDispatch();
  // const x = useNavigate();
  const token = getCookie('sesion_t');
    if (!token) {
      throw new Error('No se encontró un token de acceso');
    }
    const headers = {
      ...options.headers, // Combina encabezados existentes con Authorization
      Authorization: `Bearer ${token}`,
    };
      const response = await fetch(url, { ...options, headers });
    if (!response.ok) {
     // dispatch(logoutUser());
      //deleteCookie('sesion_t');
      //x('/admin');
      //window.location.reload();
      throw new Error(`Error en la solicitud: ${response.status} ${response.statusText}`);
    }
    return response;//.json();
  };
  export default fetchWithAuth;
